import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Attach admin Bearer token (if present) to every request — works behind ingress that strips credentialed cookies.
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bs_session_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function setSessionToken(token) {
  if (token) localStorage.setItem("bs_session_token", token);
  else localStorage.removeItem("bs_session_token");
}

export function getSessionToken() {
  return localStorage.getItem("bs_session_token") || "";
}

// Resilient image URL: proxy external customer-assets through our own origin so
// users whose ISP/firewall blocks customer-assets.emergentagent.com still see photos.
export function proxiedImage(url) {
  if (!url) return "";
  try {
    const u = new URL(url, window.location.origin);
    const proxiedHosts = ["customer-assets.emergentagent.com", "cdn.emergentagent.com"];
    if (proxiedHosts.includes(u.hostname)) {
      return `${API_BASE}/img?url=${encodeURIComponent(url)}`;
    }
    return url;
  } catch {
    return url;
  }
}

export default api;
export { BACKEND_URL };
